module.exports = __webpack_public_path__ + "static/media/mediterraneanveggiesandwich.a71b71b9.jpg";